import React from "react";

// Sophisticated live hero system: orbital rings + slow signals + a single meteor
// streak at a time (never two). CSS-driven for performance; reduced on mobile.
export default function HeroSystem() {
  return (
    <div className="fiad-hero-system" aria-hidden data-testid="hero-system">
      <div className="hero-glow" />
      <svg className="hero-orbits" viewBox="0 0 800 800" preserveAspectRatio="xMidYMid meet">
        <defs>
          <radialGradient id="hs-core" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#C79447" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#C79447" stopOpacity="0" />
          </radialGradient>
        </defs>
        {[150, 250, 340].map((r, i) => (
          <circle key={r} cx="400" cy="400" r={r} fill="none" stroke="#F6F3EC" strokeOpacity={0.06} strokeWidth="1" />
        ))}
        {/* reticle cross */}
        <line x1="400" y1="40" x2="400" y2="760" stroke="#F6F3EC" strokeOpacity="0.04" />
        <line x1="40" y1="400" x2="760" y2="400" stroke="#F6F3EC" strokeOpacity="0.04" />
        <circle cx="400" cy="400" r="26" fill="url(#hs-core)" />
        {/* orbiting signals */}
        <g className="hs-orbit hs-orbit-1"><circle cx="400" cy="250" r="3" fill="#C79447" /></g>
        <g className="hs-orbit hs-orbit-2"><circle cx="400" cy="150" r="2" fill="#F6F3EC" fillOpacity="0.7" /></g>
        <g className="hs-orbit hs-orbit-3"><circle cx="400" cy="60" r="2.5" fill="#C79447" fillOpacity="0.8" /></g>
      </svg>
      {/* single meteor — only one element ever exists */}
      <span className="hero-meteor" />
    </div>
  );
}
